import { render, staticRenderFns } from "./UserMain.vue?vue&type=template&id=263a3ab2&scoped=true&"
import script from "./UserMain.vue?vue&type=script&lang=js&"
export * from "./UserMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263a3ab2",
  null
  
)

export default component.exports